import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { initSentry } from "./observability/sentry";
import "./styles/globals.css";

// CAR-25 — init Sentry before the React tree mounts so first-render
// errors are captured. No-op when VITE_SENTRY_DSN is unset.
initSentry();

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Missing #root element");
createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
